import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogClickCta = (
  type: 'SIZE_UPLOAD' | 'SIZE_INPUT' | 'SIZE_FROM_ORDER',
) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_CTA',
      analytics: {
        TYPE: type,
      },
    });
  }, [logAnalyticsEvent, type]);
};
